import { Image } from 'antd';
import Carousel from 'components/UI/Carousel';
import Banner from 'model/Banner';
import { useMemo } from 'react';
import OffersByCategorySection from './OffersByCategorySection';
import * as S from './styles';

interface HomeNewLayoutProps {
  banners?: Banner[];
  isAuthenticated?: boolean;
}

export default function HomeNewLayout({
  banners,
  isAuthenticated,
}: HomeNewLayoutProps) {
  const staticBanner = useMemo(() => {
    const banner = banners?.find((banner) => banner.bannerType === 2);
    if (banner?.imageUrl) {
      return (
        <S.StaticBanner>
          <Image
            preview={false}
            width="100%"
            src={banner.imageUrl}
            alt="Banner estático"
          />
        </S.StaticBanner>
      );
    }
    return null;
  }, [banners]);

  return (
    <S.Root>
      <S.BannerSection>
        <Carousel />
      </S.BannerSection>

      <OffersByCategorySection
        title="Ofertas LKP"
        offerTypes={['received', 'inTransit']}
        autoScroll
        isAuthenticated={isAuthenticated ?? false}
      />

      {staticBanner}

      <OffersByCategorySection
        title="Estoque no Produtor"
        offerTypes={['onSite']}
        autoScroll={false}
        isAuthenticated={isAuthenticated ?? false}
      />

      {isAuthenticated && (
        <OffersByCategorySection
          title="Ofertas Direcionadas"
          offerTypes={['directed']}
          autoScroll={false}
          isAuthenticated={isAuthenticated ?? false}
          badgeText="Direcionada"
        />
      )}

      {isAuthenticated && (
        <OffersByCategorySection
          title="Ofertas Exclusivas"
          autoScroll={false}
          isAuthenticated={isAuthenticated ?? false}
          badgeText="Exclusiva"
          isMyOffers
        />
      )}
    </S.Root>
  );
}
